import React from 'react';
import { FieldContainer } from 'public/components/FieldContainer';
import ModularDatePicker from 'public/components/ModularComponents/DatePicker';

export default function DateInput({ input, handleInputChange, value }) {
  const { name, label, required, placeholder } = input.fields;

  return (
    <FieldContainer>
      <label htmlFor={name}>{`${label}${required ? ' *' : ''}`}</label>
      <ModularDatePicker
        date={value}
        setDate={(date) => handleInputChange({ ...input.fields, value: date })}
        placeholder={placeholder}
      />
    </FieldContainer>
  );
}
